import { createSelector } from 'reselect'
import { RdotUserRoleEnum } from '../../../../../../../store/user/rdotUser'
import { getRdotUserRoles } from '../../../../../../../store/user/selectors'

export const getIsHurdleAdmin = createSelector([getRdotUserRoles], (roles) =>
  roles?.some((role) => role === RdotUserRoleEnum.Advisory_HurdlesAdmin)
)
